import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";

const lesson: Lesson = {
  id: "3ed4d88e-9f41-4323-a3f5-026a111fb3b2",
  publicId: "15",
  name: "Electrodynamic microphone",
  difficulty: 2,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, task01, task02, task03],
};

export default lesson;
